<template>
  <v-card class="user-history" tile>
    <v-card-title>{{ this.$t('statistics.granularity') }}</v-card-title>
    <div class="pa-2 pl-4">
      <dl v-if="charts" class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.chart') }}</dt>
        <dd class="d-table-cell sts-form-radio-mgt-0">
          <v-radio-group v-model="vms.charts" row dense hide-details>
            <v-radio :label="item.label" :value="item.value" v-for="(item, index) in chartOptions" :key="index" v-show="item.isShow"></v-radio>
          </v-radio-group>
        </dd>
      </dl>
      <dl v-if="grids" class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.table') }}</dt>
        <dd class="d-table-cell sts-form-radio-mgt-0">
          <v-radio-group v-model="vms.grids" row dense hide-details>
            <v-radio :label="item.label" :value="item.value" v-for="(item, idx) in gridOptions" :key="idx" v-show="item.isShow"></v-radio>
          </v-radio-group>
        </dd>
      </dl>
    </div>
  </v-card>
</template>

<script>
export default {
  components: {},
  props: {
    charts: Array,
    grids: Array,
  },
  data() {
    return {
      defaultChartVal: '1H',
      defaultGridVal: '1d',
      vms: {
        charts: null,
        grids: null,
      },
    };
  },
  computed: {
    options() {
      const opts = [
        { label: this.$t('statistics.fiveM'), value: '5m' },
        { label: this.$t('statistics.oneH'), value: '1H' },
        { label: this.$t('statistics.oneD'), value: '1d' },
        { label: this.$t('statistics.oneM'), value: '1M' },
      ];
      return opts;
    },
    chartOptions() {
      return this.makeOps();
    },
    gridOptions() {
      return this.makeOps('grids');
    },
  },
  watch: {
    vms: {
      deep: true,
      handler: 'vmsChangeHandler',
    },
  },
  updated() {
    const charts = this.makeOps('charts').filter(el => el.isShow);
    if (!charts.find(el => el.value == this.vms.charts)) this.vms.charts = charts[0].value;
    const grids = this.makeOps('grids').filter(el => el.isShow);
    if (!grids.find(el => el.value == this.vms.grids)) this.vms.grids = grids[0].value;
    this.vmsChangeHandler(this.vms);
  },
  created() {
    this.initDefaultValue();
  },
  methods: {
    vmsChangeHandler(val) {
      const chart = this.getDateLength(val.charts);
      const grid = this.getDateLength(val.grids, 'grids');
      const granularityValue = { ...val, ...chart, ...grid };
      // console.log('granularity', granularityValue);
      this.$emit('changeGranularity', granularityValue, 'granularity');
    },
    initDefaultValue() {
      this.vms = {
        charts: this.defaultChartVal,
        grids: this.defaultGridVal,
      };
    },
    makeOps(type = 'charts') {
      return this.options.map(el => {
        return {
          ...el,
          isShow: this.$props[type].includes(el.value),
        };
      });
    },
    getDateLength(values, type = 'charts') {
      let dateFormat = '';
      let dateLength = '';
      let val = values.slice(-1);
      switch (val) {
        case 'm':
          dateLength = 12;
          dateFormat = 'yyyy-MM-dd HH:mm';
          break;
        case 'H':
          dateLength = 10;
          dateFormat = 'yyyy-MM-dd HH';
          break;
        case 'd':
          dateLength = 8;
          dateFormat = 'yyyy-MM-dd';
          break;
        default:
          dateLength = 6;
          dateFormat = 'yyyy-MM';
      }
      return {
        [`${type}Length`]: dateLength,
        [`${type}Format`]: dateFormat,
      };
    },
  },
};
</script>
